"use client";

import React, { useEffect, useState, useRef } from "react";

type ModalProps = {
  isOpen: boolean;
  onClose: () => void;
  titleVideo?: string | null;
  videoUrl?: string | null;
};


const extractYouTubeId = (url: string): string | null => {
  const regex =
    /(?:youtube\.com\/(?:[^/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?/ ]{11})/;
  const match = url.match(regex);
  return match ? match[1] : null;
};

export default function ModalVideoMedia({
  isOpen,
  onClose,
  titleVideo,
  videoUrl,
}: ModalProps) {
  const [currentVideoUrl, setCurrentVideoUrl] = useState<string | null>(null);
  const dialogRef = useRef<HTMLDialogElement>(null);


  useEffect(() => {
    if (dialogRef.current) {
      if (isOpen) {
        setCurrentVideoUrl(videoUrl || null);
        dialogRef.current.showModal();
      } else {
        setCurrentVideoUrl(null);
        dialogRef.current.close();
      }
    }
  }, [isOpen, videoUrl]);

  if (!isOpen) return null;

  return (
    <dialog
      ref={dialogRef}
      onClose={onClose}
      className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50"
    >
      <div className="bg-white p-6 rounded shadow-lg w-[90%] md:w-[650px]">
        {titleVideo && <h2 className="text-lg font-bold mb-4">{titleVideo}</h2>}

        {/* Video de YouTube embebido */}
        <div className="relative aspect-w-16 aspect-h-9">
          {currentVideoUrl ? (
            <iframe
              width="100%"
              height="315"
              src={`https://www.youtube.com/embed/${extractYouTubeId(currentVideoUrl ?? "")}?rel=0&autoplay=1`}
              title={titleVideo || "Video"}
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          ) : (
            <p className="text-gray-500 text-center">No hay video disponible</p>
          )}
        </div>

        {/* Botón para cerrar el modal */}
        <div className="mt-4 text-right">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-200 text-gray-700 rounded hover:bg-gray-300"
          >
            Cerrar
          </button>
        </div>
      </div>
    </dialog>
  );
}
